import { HeroSearch } from "./HeroSearch";

export function HeroSection() {
  return (
    <section className="relative z-10 overflow-hidden pt-32 pb-16 md:pt-40 md:pb-20">
      {/* Decorative top gradient shadow matching Lexoor */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-0"
        style={{
          backgroundImage: "radial-gradient(60% 50% at 50% 0%, oklch(0.55 0.2 258 / 0.18), transparent 70%)",
        }}
      />
      <div className="relative mx-auto max-w-[1200px] px-6">
        <div className="mx-auto flex flex-col items-center text-center">
          {/*
            SEO notes:
            1. H1 includes high-volume keywords: doctor, near you, book, appointment, online.
               Previous copy ("Find your perfect healthcare provider instantly") lacked these terms.
            2. opacity-0 removed from initial class list. The animation keyframe itself starts from
               opacity:0 so there is no visible flash, but the SSR-rendered text is NOT hidden by
               a static CSS class — conservative crawlers (Bingbot, Yandex) that evaluate
               opacity-0 as "hidden content" will now see the text correctly.
            3. Provider count added as crawlable stat below H1. "6.3M+ providers" is the
               single highest-value GEO citation hook on the site — it differentiates Heallexa
               from all competitors and is the first fact AI search engines will quote.
          */}
          <h1 className="text-[clamp(2.25rem,5vw,3.75rem)] font-medium leading-[1.05] tracking-[-0.04em] text-foreground max-w-[820px] animate-fade-up">
            Find a doctor near you
          </h1>

          <p className="mt-5 text-base leading-relaxed text-muted-foreground max-w-[560px] mx-auto animate-fade-up-delay">
            Search thousands of doctors by location, name, or specialities.
          </p>

          <div className="mt-4 w-full animate-fade-up-delay">
            <HeroSearch />
          </div>
        </div>
      </div>
    </section>
  );
}
